import { VehicleCategory } from "../types/enums/vehicles";
import { DealerData, Language, VehicleData } from "../types";

interface EventData {
  [key: string]: object;
};

export const createEventInfo = (category?: string) => {
  if (category) {
    let type;
    switch (category) {
      case VehicleCategory.NEW:
        type = "New";
        break;
      case VehicleCategory.USED:
        type = "Used";
        break;
      case VehicleCategory.CERTIFIED:
        type = "Certified";
        break;
      case VehicleCategory.DEMO:
        type = "Demo";
        break;
    }
    const contentId = `${type} Vehicle Details`;
    return {
      contentId,
      brand: "passenger"
    }
  }

  return {
    // eventAction: "STRING",
    // activatedFeatures: "OBJECT",
    // abTestFeatures: "OBJECT",
    // contentId: "STRING",
    // contentLabels: "OBJECT",
    // sectionName: "STRING",
    // templateType: "STRING",
    brand: "passenger"
  }
};

const createEnvironment = () => {
  return {
    // applicationIdVersion: "STRING",
    // featureAppIdAppVersion: "STRING",
    // featureAppVariant: "STRING",
    // region: this.event_data.environment.region,
    // commerce: false
  }
};

const createUser = (event?: string) => {
  const data: {
    loginStatus?: boolean;
    customerType?: string;
    customerContractsCount?: Array<any>;
    dealerStatus?: boolean;
  } = {
    loginStatus: false,
  }
  switch (event) {
    case "VWBasic_Button_Click":
      data.customerType = "private";
      data.customerContractsCount = undefined;
      data.dealerStatus = false;
      break;
    case "VWBasic_CTA_Click":
    case "VWBasic_FilterSearchButton_Click":
      data.dealerStatus = false;
      break;
  }
  return data;
};

export const createContent = () => {
};

export const createPersonalization = () => {
  return {
    status: false,
  }
};

export const createConfiguration = (event?: string, configuration?: VehicleData, lang?: Language) => {
  if (!configuration || !lang) {
    return {};
  }

  const data: {
    Manufacturer?: string;
    BodyTypeName?: string;
    CarlineId?: string;
    CarlineName?: string;
    SalesgroupId?: string;
    SalesgroupName?: string;
    EquipmentlineName?: string;
    ModelId?: string;
    ModelName?: string;
    ModelYear?: string;
    ExteriorColorCode?: string;
    ExteriorColorName?: string;
    InteriorColorCode?: string;
    InteriorColorName?: string;
    PriceType?: string;
    PriceTypeParameter?: Array<any>,
    PriceRateCurrency?: string;
    PriceRateType?: string;
    PriceRateBasic?: string;
    PriceRateAdditional?: string;
    PriceRateTotal?: string;
    PriceTotalCurrency?: string;
    PriceTotalBasic?: string;
    PriceTotalAdditional?: string;
    PriceTotalTotal?: number;
    UsedVehicle?: boolean;
    UsedVehicleRegistrationDate?: string;
    UsedVehicleMileage?: number;
    vehicleidentificationnumber?: string;
  } = {
    // BodyTypeName: "STRING",
    // CarlineId: "STRING",
    CarlineName: configuration.model_name,
    // SalesgroupId: "STRING",
    SalesgroupName: `${configuration.year} ${configuration.model_name}`,
    EquipmentlineName: configuration.trim?.[lang],
    ModelId: configuration.model_code,
    ModelName: configuration.model_name,
    ModelYear: `${configuration.year}`,
    // ModelModelVersion: "INTEGER",
    // ModelGearType: "STRING",
    // EnginePowerHPKW: "STRING",
    ExteriorColorCode: configuration.color_exterior.code,
    ExteriorColorName: configuration.color_exterior.label?.[lang],
    // ExteriorColorIsRecommendation: "BOOLEAN",
    InteriorColorCode: configuration.color_interior.code,
    InteriorColorName: configuration.color_interior.label?.[lang],
    // InteriorColorIsRecommendation: "BOOLEAN",
    // WheelsBasicId: "STRING",
    // WheelsBasicName: "STRING",
    // WheelsBasicSize: "STRING",
    // WheelsBasicType: "STRING",
    // PriceType: "STRING",
    // PriceTypeParameter: "ARRAY",
    // PriceRateCurrency: "ISO4217",
    // PriceRateType: "STRING",
    // PriceRateBasic: "STRING",
    // PriceRateAdditional: "STRING",
    // PriceRateTotal: "STRING",
    // PriceTotalCurrency: "ISO4217",
    // PriceTotalBasic: "STRING",
    // PriceTotalAdditional: "STRING",
    // PriceTotalTotal: configuration.price,
    UsedVehicle: configuration.category !== VehicleCategory.NEW,
    // UsedVehicle: configuration.category !== VehicleCategory.NEW,
    // UsedVehicleCondition: "OBJECT",
    UsedVehicleMileage: configuration.mileage,
    // UsedVehicleComissionNumber: "STRING",
    // vehicleList: "ARRAY",
    vehicleidentificationnumber: configuration.vin,
    // RemoteModelData: "BOOLEAN",
    // matchType: "STRING"
  };

  switch (event) {
    case "VWBasic_VehicleButton_Click":
      data.Manufacturer = "Volkswagen";
      data.PriceTotalTotal = configuration.price;
      data.UsedVehicleRegistrationDate = configuration.inventory_date as string;
      break;
    case "VWBasic_VehicleErrorMessage_Load":
      data.PriceTotalTotal = configuration.price;
      break;
    // duplicate case
    // case "VWBasic_VehicleButton_Click":
    //   data.UsedVehicleRegistrationDate = configuration.inventory_date;
    //   break;
    case "VWBasic_Vehicle_Pageload":
      data.Manufacturer = "Volkswagen";
      data.PriceType = 'price';
      data.PriceTotalCurrency = 'CAD';
      if (configuration.pcs) { // new vehicles
        data.PriceTotalAdditional = `${configuration.pcs[lang].additional_prices_total}`;
        data.PriceTotalBasic = `${configuration.price}`;
        data.PriceTotalTotal = configuration.pcs[lang].price.value as number;
      } else { // used vehicles
        data.PriceTotalTotal = configuration.price;
      }
      break;
  }

  return data;
};

export const createPartner = (dealer?: DealerData) => {
  if (!dealer) {
    return {
      informationBnr: undefined,
      informationName: undefined,
      informationZIP: undefined,
      informationDistance: undefined
    }
  }
  return {
    informationBnr: dealer.dealer_id,
    informationName: dealer.name,
    // informationDepartment: "STRING",
    informationZIP: dealer.postal,
    informationDistance: dealer.distance
  }
};

const processSteps = [
  {
    StepName: "Start your search",
    StepNumber: "1A"
  },
  {
    StepName: "Select your next Volkswagen",
    StepNumber: "1B"
  },
  {
    StepName: "View search results",
    StepNumber: "2A"
  },
  {
    StepName: "View favourites",
    StepNumber: "2B"
  },
  {
    StepName: "View vehicle details",
    StepNumber: "3"
  }
];

export const createProcess = (number: string) => {
  return processSteps.filter(step => step.StepNumber === number)[0];
};

export const createConstantData = (event?: string, category?: string) => {
  const obj = {} as EventData;
  obj.eventInfo = createEventInfo(category);
  obj.environment = createEnvironment();
  obj.user = createUser(event);
  obj.personalization = createPersonalization();
  return obj;
};
